// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../schema/public';

import { gql } from '@apollo/client';
import { CasinoErrorsFragmentDoc } from '../../components/Game/graphql/CasinoErrorsFragment.generated';
export type GameSessionFragment = { __typename?: 'CasinoStartGameSessionPayload', url?: string, errors?: Array<{ __typename?: 'CasinoError', code?: number, message?: string, params?: Array<{ __typename?: 'CasinoErrorParam', name?: string, value?: string }> }> };

export const GameSessionFragmentDoc = /*#__PURE__*/ gql`
    fragment GameSessionFragment on CasinoStartGameSessionPayload {
  url
  errors {
    ...CasinoErrorsFragment
  }
}
    ${CasinoErrorsFragmentDoc}`;